import { getCurrentOrg } from './getCurrentOrg';
import { ConversationBillingControllerService } from '../services/conversations-billing';
import type {
  AgentBillingResponseDto,
  AgentsBillingResponseDto,
  PageConversationBillingResponseDto,
} from '../services/conversations-billing';

export type ConversationBilling = PageConversationBillingResponseDto;
export type AgentsBilling = AgentsBillingResponseDto;
export type AgentBilling = AgentBillingResponseDto;

export type ConversationBillingPayload = {
  xAiAgentOrganizationContext: string;
  agentId?: string;
  conversationId?: string;
  startTime?: string;
  endTime?: string;
  page?: number;
  size: number;
  sort?: Array<string>;
};

export type AgentsBillingPayload = {
  xAiAgentOrganizationContext: string;
  startTime?: string;
  endTime?: string;
};

export type AgentBillingPayload = {
  xAiAgentOrganizationContext: string;
  agentId: string;
  startTime?: string;
  endTime?: string;
};

export const getConversationBilling = async (
  payload: Omit<ConversationBillingPayload, 'xAiAgentOrganizationContext'>
): Promise<ConversationBilling> => {
  return await ConversationBillingControllerService.getConversationBilling(
    getCurrentOrg(),
    payload.agentId,
    payload.conversationId,
    payload.startTime,
    payload.endTime,
    payload.page,
    payload.size,
    payload.sort
  );
};

export const getAgentsBilling = async (
  payload: Omit<AgentsBillingPayload, 'xAiAgentOrganizationContext'>
): Promise<AgentsBilling> => {
  return await ConversationBillingControllerService.getAgents(
    getCurrentOrg(),
    payload.startTime,
    payload.endTime
  );
};

export const getAgentBillingById = async (
  payload: Omit<AgentBillingPayload, 'xAiAgentOrganizationContext'>
): Promise<AgentBilling> => {
  return await ConversationBillingControllerService.getAgent(
    getCurrentOrg(),
    payload.agentId,
    payload.startTime,
    payload.endTime
  );
};

export const getBillingLastRefreshedDate = async (): Promise<string> => {
  return await ConversationBillingControllerService.getLastRefreshedDate(
    getCurrentOrg()
  );
};
